import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  EDisplayType,
  ProjectDetailContext,
} from "../../../pages/ProjectDetail";

export type RemoveContextType = {
  countSelection: number;
  setCountSelection: (value: number) => void;
  totalCount: number;
  setTotalCount: (value: number) => void;
  maxCountSelection: number;
  setMaxCountSelection: (value: number) => void;
};

export const RemoveContext = createContext<RemoveContextType>({
  countSelection: null,
  totalCount: null,
} as RemoveContextType);

export default RemoveContext;

export const RemoveContextProvider = (props: { children: ReactNode }) => {
  const [countSelection, setCountSelection] = useState<number>(0);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [maxCountSelection, setMaxCountSelection] = useState<number>(0);

  const { displayType } = useContext(ProjectDetailContext);

  useEffect(() => {
    if (displayType === EDisplayType.Web) {
      const ua = navigator.userAgent;
      if (ua.indexOf("Windows") > 0) {
        setMaxCountSelection(35);
      } else {
        setMaxCountSelection(15);
      }
    } else {
      setMaxCountSelection(15);
    }
  }, []);

  const contextValue = {
    countSelection,
    setCountSelection,
    totalCount,
    setTotalCount,
    maxCountSelection,
    setMaxCountSelection,
  };

  return (
    <RemoveContext.Provider value={contextValue}>
      {props.children}
    </RemoveContext.Provider>
  );
};
